import platformBackendClient from '@backend-clients/platform-backend';

export default {
  getScans: () => platformBackendClient.get('/api/skydio/scans'),
  getFlights: (withIn) => platformBackendClient.get('/api/skydio/flights', { params: { withIn } }),
  import: (body, query) => platformBackendClient.post('/api/skydio/import', body, { params: query }),
  importByFlight: (body, flightId) => platformBackendClient.post(`/api/skydio/import/flight/${flightId}`, body),
};
